import { Icon, Tooltip } from '@blueprintjs/core';
import { useContext } from 'react';
import { HeartbeatContext } from '../HeartbeatProvider';

export function HeartbeatStatus() {
  const { isActive } = useContext(HeartbeatContext);
  return (
    <Tooltip content={isActive ? 'Heartbeat Active' : 'Heartbeat Offline'}>
      <Icon
        icon={isActive ? 'pulse' : 'offline'}
        intent={isActive ? 'primary' : 'warning'}
      />
    </Tooltip>
  );
}
